import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  open: false,
};

const navSlice = createSlice({
  name: "nav",
  initialState,
  reducers: {
    toggleNav: (state) => {
      state.open = !state.open;
    },
  },
});

export const { toggleNav } = navSlice.actions;

export const NavReducer = navSlice.reducer;
